export const GET_JOBS = "GET_JOBS";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const GET_STUDENTINTIATION = "GET_STUDENTINTIATION";
export const GET_VUGTRANSACTIONS = "GET_VUGTRANSACTIONS";
